import React, { createContext, useContext, useEffect, useState } from "react";
import { supabase } from "./supabase";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [session, setSession] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [interceptorReady, setInterceptorReady] = useState(false);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setUser(session?.user ?? null);
      setIsLoading(false);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      setUser(session?.user ?? null);
      setIsLoading(false);
    });

    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    const interceptor = api.interceptors.request.use(async (config) => {
      if (session?.access_token) {
        config.headers.Authorization = `Bearer ${session.access_token}`;
      }
      return config;
    });
    
    setInterceptorReady(true);

    return () => {
      api.interceptors.request.eject(interceptor);
    };
  }, [session]);

  const logout = async () => {
    await supabase.auth.signOut();
    window.location.replace("/login");
  };

  if (!interceptorReady) {
    return null; // Wait for interceptor to be configured before any child effects run
  }

  return (
    <AuthCtx.Provider value={{ user, setUser, session, loading: isLoading, refresh: async () => {}, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
